// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container for each bot message */
.bot-message-container {
    margin-bottom: 30px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
  }

  .bot-i{
    width: 80px;
    height: 80px;
  }
  
  /* Content inside the bot message */
  .bot-message-content {
    padding: 50px;
    background-color: #FFFFFF;
    box-shadow: 4px 2px 15px 2px #7090B033;
    border-radius: 14px;
    display: flex;
    flex-direction: column;
    width: 60%;
  }
  
  /* Header section containing the emoji and message text */
  .message-header {
    display: flex;
    flex-direction: row;
  }
  
  /* Emoji smile icon */
  .message-icon {
    margin-right: 15px;
    font-size: 24px;
  }
  
  /* Message text */
  .message-text {
    margin: 0;
    white-space: pre-wrap;
  }
  
  /* Action section containing thumbs and clipboard buttons */
  .message-actions {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
  }
  
  /* Thumbs up/down button container */
  .thumbs-container {
    display: flex;
  }
  
  /* Style for the thumbs buttons */
  .thumbs-btn {
    background-color: white;
    border-radius: 30px;
    margin-right: 10px;
    padding: 0px 10px 0px 10px;
    border: none;
  }

  .thumbs-btn:hover{
    background-color: #0b1a5b;
    color: white;
  }
  
  /* Style for the clipboard button */
  .clipboard-btn {
    background-color: white;
    border-radius: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 5px 10px;
    border: none;
  }

  .clipboard-btn:hover{
    background-color: #0b1a5b;
    color: white;
  }
  
  /* Copy text next to clipboard icon */
  .copy-text {
    font-size: 12px;
    margin-left: 10px;
  }
  
  .message-container {
    margin-bottom: 30px;
    box-sizing: border-box;
    margin-left: 21%;
    width: 60%;
    display: flex;
  }
  
  .message-content {
    display: flex;
    flex-direction: row;
    width: 86%;
    align-items: center;
    justify-content: end;
    position: relative;
  }
  
  .message-content i {
    margin-right: 10px;
    background-color: #F1F1F1;
    border-radius: 15px;
    width: 35px;
    padding: 10px;
    padding-left: 10px;
    padding-right: 10px;
    opacity: 0;
    transition: opacity 0.3s;
  }
  
  .message-content p {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 0;
    border-radius: 14px;
    border-bottom: 1px solid #C7CCD3;
    background-color: #E6E6FA;
    color:#000000;
    padding: 15px;
    border-radius: 20px;
    min-width: 100px;
    font-weight: 500;
  }

.faq{
  display: flex;
  flex-direction: row;
  margin-top: 22%;
  align-self: center;
  width: 70%;
}

.faqGuest{
  display: flex;
  flex-direction: row;
  margin-top: 12%;
  align-self: center;
  width: 70%;
}
  
  .message-content:hover i {
    opacity: 1;
  }
  .visible-word {
    opacity: 1;
    transition: opacity 0.3s ease-in;
  }
  
  .faded-word {
    opacity: 0.5;
    transition: opacity 0.3s ease-in;
  }
  
  .hidden-word {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease-out, visibility 0.3s ease-out;
  }
  /* Dark Mode Styles */
body.dark-mode {
  background-color: #1a1a1a;
  color: #e0e0e0;
}

/* Bot message container in dark mode */
body.dark-mode .bot-message-container {
  background-color: transparent;
}

/* Content inside bot message in dark mode */
body.dark-mode .bot-message-content {
  background-color: #2a2a2a; /* Darker gray for bot messages */
  box-shadow: 4px 2px 15px 2px rgba(0, 0, 0, 0.5);
  color: #e0e0e0;
}

/* Message header in dark mode */
body.dark-mode .message-header {
  color: #e0e0e0;
}

/* Message icon in dark mode */
body.dark-mode .message-icon {
  color: #bbbbbb;
}

/* Message text in dark mode */
body.dark-mode .message-text {
  color: #ffffff;
}

/* Thumbs button container in dark mode */
body.dark-mode .thumbs-btn {
  background-color: #333333;
  color: #e0e0e0;
  border: 1px solid #444; /* Add a border for better distinction */
}

body.dark-mode .thumbs-btn:hover {
  background-color: #5e17eb; /* Accent hover color */
  color: #ffffff;
}

/* Clipboard button in dark mode */
body.dark-mode .clipboard-btn {
  background-color: #333333;
  color: #e0e0e0;
  border: 1px solid #444;
}

body.dark-mode .clipboard-btn:hover {
  background-color: #5e17eb;
  color: #ffffff;
}

/* Copy text in dark mode */
body.dark-mode .copy-text {
  color: #e0e0e0;
}

/* User message container in dark mode */
body.dark-mode .message-container {
  background-color: transparent;
}

/* Content inside user message in dark mode */
body.dark-mode .message-content p {
  background-color: #333333; /* Lighter dark for user messages */
  border-bottom: 1px solid #444;
  color: #e0e0e0;
}

/* Message icon in dark mode */
body.dark-mode .message-content i {
  background-color: #444;
}

body.dark-mode .message-content p {
  background-color: #1e1e1e; /* Darker background for user messages */
  border: 1px solid #5e17eb; /* Vivid purple border */
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(94, 23, 235, 0.5); /* Subtle purple shadow */
}

/* Hover effect for icon in dark mode */
body.dark-mode .message-content:hover i {
  opacity: 1;
}




@media (max-width: 768px) {
  .bot-message-content {
    padding: 15px;
    background-color: #FFFFFF;
    box-shadow: 4px 2px 15px 2px #7090B033;
    border-radius: 14px;
    display: flex;
    flex-direction: column;
    width: 75%;
  }
  .message-container {
    margin-bottom: 10px;
    margin-left: 21%;
    width: 85%;
  }
 
  .message-content p{
   padding: 10px;
  }
  .query-text{
    font-size: 14px;
  }
  .message-text {
    font-size: 14px;
    white-space: pre-wrap;
  }
  .bot-i{
    width: 60px;
    height: 60px;
  }
  .faq{
    width: 90%;
    margin-top: 52%;
  }

  .faqGuest{
    margin-top: 12%;
    width: 90%;
  }

}

@media (max-width: 568px) {
  .bot-i{
    width: 50px;
    height: 50px;
  }

  .message-container {
    margin-bottom: 0px;
  }
  .bot-message-container{
    margin-bottom: 10px;
    justify-content: flex-start;
  }
  .query-text{
    font-size: 13px;
  }
  .message-text {
    font-size: 13px;
  }
  .bot-message-content{
    width: 82%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/PromptRes.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA,mCAAmC;EACnC;IACE,aAAa;IACb,yBAAyB;IACzB,sCAAsC;IACtC,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,UAAU;EACZ;;EAEA,yDAAyD;EACzD;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA,qBAAqB;EACrB;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA,iBAAiB;EACjB;IACE,SAAS;IACT,qBAAqB;EACvB;;EAEA,2DAA2D;EAC3D;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA,oCAAoC;EACpC;IACE,aAAa;EACf;;EAEA,iCAAiC;EACjC;IACE,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA,mCAAmC;EACnC;IACE,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA,qCAAqC;EACrC;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,gCAAgC;IAChC,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;EAClB;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;EAEE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,gCAAgC;EAClC;;EAEA;IACE,YAAY;IACZ,gCAAgC;EAClC;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,2DAA2D;EAC7D;EACA,qBAAqB;AACvB;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,6BAA6B;AAC/B;;AAEA,4CAA4C;AAC5C;EACE,yBAAyB,EAAE,iCAAiC;EAC5D,+CAA+C;EAC/C,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,yBAAyB;EACzB,cAAc;EACd,sBAAsB,EAAE,wCAAwC;AAClE;;AAEA;EACE,yBAAyB,EAAE,uBAAuB;EAClD,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;EACzB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,6BAA6B;AAC/B;;AAEA,6CAA6C;AAC7C;EACE,yBAAyB,EAAE,mCAAmC;EAC9D,6BAA6B;EAC7B,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB,EAAE,wCAAwC;EACnE,yBAAyB,EAAE,wBAAwB;EACnD,cAAc;EACd,6CAA6C,EAAE,yBAAyB;AAC1E;;AAEA,uCAAuC;AACvC;EACE,UAAU;AACZ;;;;;AAKA;EACE;IACE,aAAa;IACb,yBAAyB;IACzB,sCAAsC;IACtC,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;EACZ;;EAEA;GACC,aAAa;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;AAEF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":["/* Container for each bot message */\n.bot-message-container {\n    margin-bottom: 30px;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    width: 100%;\n  }\n\n  .bot-i{\n    width: 80px;\n    height: 80px;\n  }\n  \n  /* Content inside the bot message */\n  .bot-message-content {\n    padding: 50px;\n    background-color: #FFFFFF;\n    box-shadow: 4px 2px 15px 2px #7090B033;\n    border-radius: 14px;\n    display: flex;\n    flex-direction: column;\n    width: 60%;\n  }\n  \n  /* Header section containing the emoji and message text */\n  .message-header {\n    display: flex;\n    flex-direction: row;\n  }\n  \n  /* Emoji smile icon */\n  .message-icon {\n    margin-right: 15px;\n    font-size: 24px;\n  }\n  \n  /* Message text */\n  .message-text {\n    margin: 0;\n    white-space: pre-wrap;\n  }\n  \n  /* Action section containing thumbs and clipboard buttons */\n  .message-actions {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 10px;\n  }\n  \n  /* Thumbs up/down button container */\n  .thumbs-container {\n    display: flex;\n  }\n  \n  /* Style for the thumbs buttons */\n  .thumbs-btn {\n    background-color: white;\n    border-radius: 30px;\n    margin-right: 10px;\n    padding: 0px 10px 0px 10px;\n    border: none;\n  }\n\n  .thumbs-btn:hover{\n    background-color: #0b1a5b;\n    color: white;\n  }\n  \n  /* Style for the clipboard button */\n  .clipboard-btn {\n    background-color: white;\n    border-radius: 20px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 5px 10px;\n    border: none;\n  }\n\n  .clipboard-btn:hover{\n    background-color: #0b1a5b;\n    color: white;\n  }\n  \n  /* Copy text next to clipboard icon */\n  .copy-text {\n    font-size: 12px;\n    margin-left: 10px;\n  }\n  \n  .message-container {\n    margin-bottom: 30px;\n    box-sizing: border-box;\n    margin-left: 21%;\n    width: 60%;\n    display: flex;\n  }\n  \n  .message-content {\n    display: flex;\n    flex-direction: row;\n    width: 86%;\n    align-items: center;\n    justify-content: end;\n    position: relative;\n  }\n  \n  .message-content i {\n    margin-right: 10px;\n    background-color: #F1F1F1;\n    border-radius: 15px;\n    width: 35px;\n    padding: 10px;\n    padding-left: 10px;\n    padding-right: 10px;\n    opacity: 0;\n    transition: opacity 0.3s;\n  }\n  \n  .message-content p {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    margin: 0;\n    border-radius: 14px;\n    border-bottom: 1px solid #C7CCD3;\n    background-color: #E6E6FA;\n    color:#000000;\n    padding: 15px;\n    border-radius: 20px;\n    min-width: 100px;\n    font-weight: 500;\n  }\n\n.faq{\n  display: flex;\n  flex-direction: row;\n  margin-top: 22%;\n  align-self: center;\n  width: 70%;\n}\n\n.faqGuest{\n  display: flex;\n  flex-direction: row;\n  margin-top: 12%;\n  align-self: center;\n  width: 70%;\n}\n  \n  .message-content:hover i {\n    opacity: 1;\n  }\n  .visible-word {\n    opacity: 1;\n    transition: opacity 0.3s ease-in;\n  }\n  \n  .faded-word {\n    opacity: 0.5;\n    transition: opacity 0.3s ease-in;\n  }\n  \n  .hidden-word {\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.3s ease-out, visibility 0.3s ease-out;\n  }\n  /* Dark Mode Styles */\nbody.dark-mode {\n  background-color: #1a1a1a;\n  color: #e0e0e0;\n}\n\n/* Bot message container in dark mode */\nbody.dark-mode .bot-message-container {\n  background-color: transparent;\n}\n\n/* Content inside bot message in dark mode */\nbody.dark-mode .bot-message-content {\n  background-color: #2a2a2a; /* Darker gray for bot messages */\n  box-shadow: 4px 2px 15px 2px rgba(0, 0, 0, 0.5);\n  color: #e0e0e0;\n}\n\n/* Message header in dark mode */\nbody.dark-mode .message-header {\n  color: #e0e0e0;\n}\n\n/* Message icon in dark mode */\nbody.dark-mode .message-icon {\n  color: #bbbbbb;\n}\n\n/* Message text in dark mode */\nbody.dark-mode .message-text {\n  color: #ffffff;\n}\n\n/* Thumbs button container in dark mode */\nbody.dark-mode .thumbs-btn {\n  background-color: #333333;\n  color: #e0e0e0;\n  border: 1px solid #444; /* Add a border for better distinction */\n}\n\nbody.dark-mode .thumbs-btn:hover {\n  background-color: #5e17eb; /* Accent hover color */\n  color: #ffffff;\n}\n\n/* Clipboard button in dark mode */\nbody.dark-mode .clipboard-btn {\n  background-color: #333333;\n  color: #e0e0e0;\n  border: 1px solid #444;\n}\n\nbody.dark-mode .clipboard-btn:hover {\n  background-color: #5e17eb;\n  color: #ffffff;\n}\n\n/* Copy text in dark mode */\nbody.dark-mode .copy-text {\n  color: #e0e0e0;\n}\n\n/* User message container in dark mode */\nbody.dark-mode .message-container {\n  background-color: transparent;\n}\n\n/* Content inside user message in dark mode */\nbody.dark-mode .message-content p {\n  background-color: #333333; /* Lighter dark for user messages */\n  border-bottom: 1px solid #444;\n  color: #e0e0e0;\n}\n\n/* Message icon in dark mode */\nbody.dark-mode .message-content i {\n  background-color: #444;\n}\n\nbody.dark-mode .message-content p {\n  background-color: #1e1e1e; /* Darker background for user messages */\n  border: 1px solid #5e17eb; /* Vivid purple border */\n  color: #ffffff;\n  box-shadow: 0 4px 12px rgba(94, 23, 235, 0.5); /* Subtle purple shadow */\n}\n\n/* Hover effect for icon in dark mode */\nbody.dark-mode .message-content:hover i {\n  opacity: 1;\n}\n\n\n\n\n@media (max-width: 768px) {\n  .bot-message-content {\n    padding: 15px;\n    background-color: #FFFFFF;\n    box-shadow: 4px 2px 15px 2px #7090B033;\n    border-radius: 14px;\n    display: flex;\n    flex-direction: column;\n    width: 75%;\n  }\n  .message-container {\n    margin-bottom: 10px;\n    margin-left: 21%;\n    width: 85%;\n  }\n \n  .message-content p{\n   padding: 10px;\n  }\n  .query-text{\n    font-size: 14px;\n  }\n  .message-text {\n    font-size: 14px;\n    white-space: pre-wrap;\n  }\n  .bot-i{\n    width: 60px;\n    height: 60px;\n  }\n  .faq{\n    width: 90%;\n    margin-top: 52%;\n  }\n\n  .faqGuest{\n    margin-top: 12%;\n    width: 90%;\n  }\n\n}\n\n@media (max-width: 568px) {\n  .bot-i{\n    width: 50px;\n    height: 50px;\n  }\n\n  .message-container {\n    margin-bottom: 0px;\n  }\n  .bot-message-container{\n    margin-bottom: 10px;\n    justify-content: flex-start;\n  }\n  .query-text{\n    font-size: 13px;\n  }\n  .message-text {\n    font-size: 13px;\n  }\n  .bot-message-content{\n    width: 82%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
